export const URL: string = 'https://netgfx.com/trunk/thelist/'
